import { ApiProject } from "@incendium/api";
import { listAllProjects } from "features/project/services/projectService";
import { useGlobalSharedState } from "Hooks/useSharedState";

const fetchAllProjects = async () => {
  const projects = await listAllProjects();
  return projects || [];
};

const useAllProjects = () => {
  const { state, setState, loading, refetch, fetched } = useGlobalSharedState<ApiProject[]>(
    "allProjects",
    [],
    fetchAllProjects
  );

  return {
    allProjects: state,
    setAllProjects: setState,
    loading,
    refetch,
    fetched,
  };
};

export default useAllProjects;
